<i18n>
{
  "en": {
    "loginCardMessage": "Please Login",
    "notFoundUserData": "Not found user data",
    "notFoundUserDataMessage": "Please login again",
    "needInviteTitle": "In the process of testing",
    "needInviteText": "Please contact our developer team for testing invite"
  },
  "th": {
    "loginCardMessage": "กรุณาเข้าสู่ระบบ",
    "notFoundUserData": "ไม่พบข้อมูลผู้ใช้",
    "notFoundUserDataMessage": "กรุณาเข้าสู่ระบบอีกครั้ง",
    "needInviteTitle": "อยู่ระหว่างการทดสอบระบบ",
    "needInviteText": "กรุณาติดต่อนักพัฒาของเราเพื่อขออนุมัติร่วมทดสอบระบบ"
  }
}
</i18n>
<template>
  <v-layout
    class="pt-12 pb-12"
    align-center
    justify-center
  >
    <v-flex
      xs12
      sm8
      md6
      lg4
      :class="{ 'mt-sm-12': noErrors }"
    >
      <v-alert
        border="top"
        colored-border
        type="info"
        elevation="2"
      >
        <h3 class="headline">
          {{ $t('needInviteTitle') }}
        </h3>
        <v-divider />
        <span>
          {{ $t('needInviteText') }}
        </span>
      </v-alert>

      <v-alert
        border="top"
        colored-border
        type="error"
        elevation="2"
        v-if="loginError"
      >
        <h3 class="headline">
          {{ loginError.code | capitalize }}
        </h3>
        <v-divider />
        <span>
          {{ loginError.message.toString() }}
        </span>
      </v-alert>
      <v-alert
        border="top"
        colored-border
        type="warning"
        elevation="2"
        v-if="needLogin"
      >
        <h3 class="headline">
          {{ $t(needLogin.code) }}
        </h3>
        <v-divider />
        <span>
          {{ $t(needLogin.message) }}
        </span>
      </v-alert>

      <v-card class="elevation-12 pb-5">
        <v-toolbar
          color="blue"
          dark
          flat
          v-if="noErrors"
        >
          <v-toolbar-title>{{ $t('loginCardMessage') }}</v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <v-card-text>
          <paow-facebook-login-button
            class="mt-5"
            :x-large-button="true"
            :large-icon="true"
          />
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import PaowFacebookLoginButton from '../components/PaowFacebookLoginButton'
import { mapState } from 'vuex'

export default {
  name: 'Home',
  filters: {
    capitalize (value) {
      if (!value) return 'Error'
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  components: { PaowFacebookLoginButton },
  computed: {
    ...mapState({
      loginError: state => state.errors.login,
      needLogin: state => state.errors.needLogin
    }),
    noErrors () {
      return this.loginError === null && this.needLogin === null
    }
  }
}
</script>

<style>

</style>
